import React from 'react'

interface LoaderProps {
  message?: string
  fullScreen?: boolean
}

const Loader: React.FC<LoaderProps> = ({
  message = 'Loading...',
  fullScreen = true,
}) => {
  const containerClass = fullScreen
    ? 'min-h-screen flex items-center justify-center bg-white'
    : 'flex items-center justify-center p-4'

  return (
    <div className={containerClass}>
      <div className="flex flex-col items-center justify-center space-y-3">
        <div className="h-10 w-10 border-4 border-gray-300 border-t-black rounded-full animate-spin"></div>
        <p className="text-gray-700 text-sm">{message}</p>
      </div>
    </div>
  )
}

export default Loader
